import { createSlice } from "@reduxjs/toolkit";
import { GetWorkOrderListByShop, AddWorkOrder, UpdateWorkOrder, DeleteWorkOrder, GetWorkOrderItems, GetWorkOrderItemsForChalan, GetWorkOrderDetail } from "services/workorder/workOrder.service";
import { toast } from 'react-toastify';

export const workOrderListByShopSlice = createSlice({
  name: "workOrderList",
  initialState: {
    workOrderList: [],
    workOrderListLoading: false,
    workOrderListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetWorkOrderListByShop.pending, (state) => {
      state.workOrderListLoading = true
    });

    builder.addCase(GetWorkOrderListByShop.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Work Order List Promise resolved 👌');

      state.workOrderList = action.payload
      state.workOrderListLoading = false
      state.workOrderListError = null
    });

    builder.addCase(GetWorkOrderListByShop.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Work Order List Promise rejected 🤯 😣')

      state.workOrderListLoading = false
      state.workOrderListError = action.error?.message
    });
  },
});

export const workOrderAddSlice = createSlice({
  name: "workOrderAdd",
  initialState: {
    workOrderAdd: {},
    workOrderAddLoading: false,
    workOrderAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddWorkOrder.pending, (state) => {
      // toast.loading('We are adding the work order 🤯')
      state.workOrderAddLoading = true
    });

    builder.addCase(AddWorkOrder.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New work order added successfully 👌');

      state.workOrderAdd = action.payload
      state.workOrderAddLoading = false
      state.workOrderAddError = null
    });

    builder.addCase(AddWorkOrder.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the work order 😣")

      state.workOrderAddLoading = false
      state.workOrderAddError = action.error?.message
      toast.error(action.error?.message)
    });
  },
});

export const workOrderUpdateSlice = createSlice({
  name: "workOrderUpdate",
  initialState: {
    workOrderUpdate: {},
    workOrderUpdateLoading: false,
    workOrderUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateWorkOrder.pending, (state) => {
      // toast.loading('We are updating the work order 🤯')
      state.workOrderUpdateLoading = true
    });

    builder.addCase(UpdateWorkOrder.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Work order update successfully 👌');

      state.workOrderUpdate = action.payload
      state.workOrderUpdateLoading = false
      state.workOrderUpdateError = null
    });

    builder.addCase(UpdateWorkOrder.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the work order 😣")

      state.workOrderUpdateLoading = false
      state.workOrderUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const workOrderItemsSlice = createSlice({
  name: "workOrderItems",
  initialState: {
    workOrderItems: [],
    workOrderItemsLoading: false,
    workOrderItemsError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetWorkOrderItems.pending, (state) => {
      state.workOrderItemsLoading = true
    });

    builder.addCase(GetWorkOrderItems.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.workOrderItems = action.payload
      state.workOrderItemsLoading = false
      state.workOrderItemsError = null
    });

    builder.addCase(GetWorkOrderItems.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.workOrderItemsLoading = false
      state.workOrderItemsError = action.error?.message
    });
  },
});


export const deleteWorkOrderSlice = createSlice({
  name: "deleteWorkOrder",
  initialState: {
    deleteWorkOrder: {},
  },
  reducers: {},
  extraReducers: 
  (builder) => {

    builder.addCase(DeleteWorkOrder.fulfilled, (state, action) => {
      state.deleteWorkOrder = action.payload
    });
  },
});

export const workOrderItemsForChalanSlice = createSlice({
  name: "workOrderItemsForChalan",
  initialState: {
    workOrderItemsForChalan: [],
    workOrderItemsForChalanLoading: false,
    workOrderItemsForChalanError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetWorkOrderItemsForChalan.pending, (state) => {
      state.workOrderItemsForChalanLoading = true
    });

    builder.addCase(GetWorkOrderItemsForChalan.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.workOrderItemsForChalan = action.payload
      state.workOrderItemsForChalanLoading = false
      state.workOrderItemsForChalanError = null
    });

    builder.addCase(GetWorkOrderItemsForChalan.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.workOrderItemsForChalanLoading = false
      state.workOrderItemsForChalanError = action.error?.message
    });
  },
});

export const workOrderDetailSlice = createSlice({
  name: "workOrderDetail",
  initialState: {
    workOrderDetail: [],
    workOrderDetailLoading: false,
    workOrderDetailError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetWorkOrderDetail.pending, (state) => {
      state.workOrderDetailLoading = true
    });

    builder.addCase(GetWorkOrderDetail.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved for work order detail👌');

      state.workOrderDetail = action.payload
      state.workOrderDetailLoading = false
      state.workOrderDetailError = null
    });

    builder.addCase(GetWorkOrderDetail.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected for work order detail 🤯 😣')

      state.workOrderDetailLoading = false
      state.workOrderDetailError = action.error?.message
    });
  },
});